import { Chip, ListItem, ListItemText, Stack, Typography } from "@mui/material"
import React from "react"
import { FORMAT_TYPE, formatText } from "src/utils/era-package"

export const CHIP_MAP = new Map([
  ['A', { label: 'Accepted', color: 'success' }],
  ['R', { label: 'Rejected', color: 'error' }],
  ['F', { label: 'Fatal', color: 'error' }],
  ['I', { label: 'Info', color: 'info' }],
  ['S', { label: 'Sent', color: 'info' }],
  ['C', { label: 'Cancelled', color: 'info' }],
])

const getChipProps = (severity, code) => {
  const res = CHIP_MAP.get(severity)
    || { text: '', color: 'default' }
  return {
    color: res.color,
    label: <>
      {res.label || 'Code'}:&nbsp;
      <pre style={{ display: 'inline' }}>{code}</pre>
    </>
  }
}

export const ResponseItem = ({ severity, code, message, timestamp, status }) => {
  const severityCode = status === 'A' ? 'A' : severity

  return <ListItem sx={{
    border: 1, borderColor: 'divider', borderRadius: 1,
    height: '100%', alignItems: 'flex-start',
  }}>
    <ListItemText
      primary={<Stack direction='row' spacing={1}>
        <Chip size='small'
          {...getChipProps(severityCode, code)}
        />
        <Typography>{message || 'No message'}</Typography>
      </Stack>}
      secondary={timestamp && formatText(timestamp, FORMAT_TYPE.datetime)}
      secondaryTypographyProps={{ mt: .5 }}
    />
  </ListItem>
}